import Highcharts from 'highcharts'
import stockInit from 'highcharts/modules/stock'

export default defineNuxtPlugin(() => {
  if (typeof Highcharts === 'object') {
    stockInit(Highcharts)
  }
})
